import {RootStore} from './RootStore';

export default class BaseStore {
    public root: RootStore;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/BaseStore.ts